// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import { routerPush } from '@tcp/core/src/utils';
import internalEndpoints from '@tcp/core/src/components/features/account/common/internalEndpoints';
import PointsClaimTopSection from '../molecules/PointsClaimTopSection';
import PointsClaimForm from '../molecules/PointsClaimForm';

export const PointsClaimView = ({
  successMessage,
  errorMessage,
  onSubmit,
  showNotification,
  resetPasswordErrorMessage,
  claimSubmit,
  ...otherprops
}) => {
  const onBack = () => {
    routerPush(internalEndpoints.pointsHistoryPage.link, internalEndpoints.pointsHistoryPage.path);
  };
  return (
    <React.Fragment>
      <PointsClaimTopSection onBack={onBack} className="elem-mb-XL" />
      <PointsClaimForm
        successMessage={successMessage}
        errorMessage={errorMessage}
        onSubmit={claimSubmit}
        onBack={onBack}
        resetPasswordErrorMessage={resetPasswordErrorMessage}
        showNotification={showNotification}
        {...otherprops}
      />
    </React.Fragment>
  );
};

PointsClaimView.propTypes = {
  successMessage: PropTypes.string,
  errorMessage: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  resetPasswordErrorMessage: PropTypes.string.isRequired,
  showNotification: PropTypes.bool.isRequired,
  claimSubmit: PropTypes.func.isRequired,
};

PointsClaimView.defaultProps = {
  successMessage: '',
  errorMessage: '',
};

export default PointsClaimView;
